import { Container, Typography } from "@mui/material";
import React from "react";
import BlogNewPostForm from "../components/blog/BlogNewPostForm";

const BlogNewPostPage: React.FC = () => {
  return (
    <Container className="py-5 !max-w-[90%]">
      <Typography variant="body1" className="!font-bold text-gray-700 pb-5">
        TẠO BÀI VIẾT
      </Typography>
      <BlogNewPostForm />
    </Container>
  );
};

export default BlogNewPostPage;
